/**
 * WordPress dependencies.
 */
import { __ } from "@wordpress/i18n";

const Footer = () => {
    // auto change the year
    const year = new Date().getFullYear();
    const yearText = year === 2024 ? year : `2024 - ${year}`;

  return (
    <footer className="ultrablocks-footer">
      <div className="ultrablocks-container">

        {__(
          `Copyright ©${yearText} UltraBlocks. All Rights Reserved.`,
          "ultrablocks"
        )}
      </div>
    </footer>
  );
};

export default Footer;
